import DrawerBody from "ds/components/Drawer/Body";
import FormFieldViewText from "components/FormFields/ViewText";
import { OidcSettings } from "types/generated";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import SettingsSingleSignOnConfigInfoOIDC from "../../components/ConfigInfoOIDC";
import ClaimMappingsTable from "../../components/ClaimMappingsTable";

type SettingsSingleSignOnDetailsOIDCProps = {
  integration: OidcSettings;
};

const SettingsSingleSignOnDetailsOIDC = ({ integration }: SettingsSingleSignOnDetailsOIDCProps) => {
  const hasClaimMappings = integration.claimMapping.entries.length > 0;

  return (
    <>
      <DrawerBody hasDivider gap="x-large" shrink="0">
        <SettingsSingleSignOnConfigInfoOIDC />

        <FormFieldViewText label="Admin login" value={integration.adminLogin} withCopy noMargin />
        <FormFieldViewText label="Client ID" value={integration.clientId} withCopy noMargin />
        <FormFieldViewText
          label="Provider URL"
          value={integration.identityProviderHost}
          withCopy
          noMargin
        />
      </DrawerBody>

      {hasClaimMappings && (
        <DrawerBody gap="x-large">
          <Box direction="column" gap="large" fullHeight>
            <Typography variant="p-t6" tag="h3">
              Claim Mappings
            </Typography>
            <ClaimMappingsTable mappings={integration.claimMapping.entries} />
          </Box>
        </DrawerBody>
      )}
    </>
  );
};

export default SettingsSingleSignOnDetailsOIDC;
